import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  factura: false,
  datos_factura: [],
  banks: [],
  agremiado: [],
  total_deuda: 0,
  existe_deuda: [],
  solvente_hasta: [],
  conceptos: [],
  electronic_points: [],
  form: {
    cpc: '',
    concepts: [],
    concepts_old: []
  }
}

// mutations
export const mutations = {

  [types.ADD_CPC_FORM] (state, { cpc }) {
    state.form.cpc = cpc
    state.form.concepts = []
  },

  [types.ADD_USER_CONSULT] (state, { data }) {
    state.agremiado = data.user
    state.existe_deuda = data.existe_deuda
    state.solvente_hasta = data.solvente_hasta
    state.total_deuda = data.total
  },

  [types.SET_CONCEPTS] (state, { concepts }) {
    const c = []
    concepts.forEach(element => {
      console.log(element, 'element')
      if (element.concept_cost_last_amount != null) {
        c.push(element)
      }
    })
    state.conceptos = c
  },

  [types.SET_CONCEPTSOLD_FORM] (state, { concepts }) {
    state.conceptos_old = concepts
  },

  [types.SET_BANKS] (state, { banks, electronicPonits }) {
    state.banks = banks
    state.electronic_points = electronicPonits
  },

  [types.SET_CONCEPTS_FORM] (state, { concepts }) {
    state.form.conceptos = concepts
  },

  [types.SET_MODAL_FACTURA] (state, { result, data }) {
    state.factura = result
    state.datos_factura = data
  },

  [types.SET_QTY_CONCEPT] (state, { event, index }) {
    // console.log(state.concepts.find(c => c.id === index.id))
    state.conceptos[index].qty = event
  }

}

// actions
export const actions = {

  async existCpc ({ commit, dispatch }, cpc) {
    try {
      const { data } = await axios.get(`/api/searchcpc/${cpc}`)
      if (data.exist) {
        console.log(data, 'busqueda cpc')
        commit(types.ADD_USER_CONSULT, { data: data })
        commit(types.ADD_CPC_FORM, { cpc: cpc })
      } else {
        commit(types.ADD_USER_CONSULT, { data: [] })
        commit(types.ADD_CPC_FORM, { cpc: '' })
        dispatch('responseMessage', {
          type: 'error',
          text: 'El cpc no Existe'
        })
      }
    } catch (e) {
      // commit(types.ADD_CPC_FORM_FAILURE)
    }
  },

  async fetchConceptServices ({ commit }) {
    try {
      const { data } = await axios.get(`/api/concepts/admin/getAllConcepts`)
      console.log(data, 'store pay services')
      commit(types.SET_CONCEPTS, { concepts: data })
    } catch (e) {
      // commit(types.ADD_CPC_FORM_FAILURE)
    }
  },

  async fetchConceptServicesPayRap ({ commit }, payload) {
    try {
      const { data } = await axios.post(`/api/sat-concepts/getAllConcepts`, { ruap_id: payload })
      commit(types.SET_CONCEPTS, { concepts: data })
    } catch (e) {
      console.log(e.response, 'allconceptsrap')
      // commit(types.ADD_CPC_FORM_FAILURE)
    }
  },

  async fetchBanks ({ commit }) {
    try {
      const { data } = await axios.get(`/api/pay/admin/getAllBanks`)
      commit(types.SET_BANKS, { banks: data.bancos, electronicPonits: data.electronic_point })
    } catch (e) {
      // commit(types.ADD_CPC_FORM_FAILURE)
    }
  },

  async sendPayConfirm ({ commit, dispatch }, payload) {
    try {
      const { data } = await axios.post(`/api/pay/admin/confirmPay`, payload)
      commit(types.SET_MODAL_FACTURA, { result: true, data: data })
      dispatch('responseMessage', {
        type: 'success',
        text: 'Registro del pago exitoso!'
      })
    } catch (e) {
      console.log(e.response, 'response pay error')
      // commit(types.ADD_CPC_FORM_FAILURE)
      dispatch('responseMessage', {
        type: 'error',
        text: 'Error al procesar, intente nuevamente'
      })
    }
  },

  async generarPrintFactura ({ commit, dispatch }, payload) {
    try {
      const { data } = await axios.post(`/api/sat/print-invoice`, { id: payload })
      commit(types.SET_MODAL_FACTURA, { result: true, data: data })
    } catch (e) {
      console.log(e.response, 'response pay error')
      // commit(types.ADD_CPC_FORM_FAILURE)
      dispatch('responseMessage', {
        type: 'error',
        text: 'Error al procesar, intente nuevamente'
      })
    }
  },

  async setConceptServices ({ commit }, concepts) {
    commit(types.SET_CONCEPTS_FORM, { concepts: concepts })
  },

  async setConceptOldServices ({ commit }, conceptsOld) {
    commit(types.SET_CONCEPTSOLD_FORM, { concepts: conceptsOld })
  },

  async setModalFacturaPay ({ commit }, payload) {
    commit(types.SET_MODAL_FACTURA, { result: payload })
  },

  async setQtyConcept ({ commit, state }, { event, index }) {
    // const index = state.concepts.indexOf(item)
    commit(types.SET_QTY_CONCEPT, { event: event, index: index })
  }

}

// getters
export const getters = {
  existCPC: state => state.form.cpc,
  getTotalDeuda: state => state.total_deuda,
  getAgremiadoData: state => state.agremiado,
  conceptsServices: state => state.conceptos,
  getAllBanks: state => state.banks,
  printFacturaPay: state => state.factura,
  dataFacturaPay: state => state.datos_factura,
  getElectronicPoints: state => state.electronic_points
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/pay_services.js